import { render } from "./orderSpec.vue?vue&type=template&id=c6730c04&scoped=true"
import script from "./orderSpec.vue?vue&type=script&lang=js"
export * from "./orderSpec.vue?vue&type=script&lang=js"

import "./orderSpec.vue?vue&type=style&index=0&id=c6730c04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6730c04"]])

export default __exports__